export default __webpack_public_path__ + "static/media/bellIcon.18c15d11.svg";